import { render, staticRenderFns } from "./PromosNewForm.vue?vue&type=template&id=119a9f45"
import script from "./PromosNewForm.vue?vue&type=script&lang=js"
export * from "./PromosNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports